
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import { fetchPostsCampaign } from '@/services/userService';
import HomeCampaignlistItem from './HomeCampaignlistItem.vue';
import $ from 'jquery';
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";

@Component({
  components: {
    HomeCampaignlistItem,
    LoadingAnimation,
  },
})
export default class HomeCampaignlist extends Vue {
  private　name = 'homecampaignlist';
  private defaultItems: number = 4;
  private list: PostDataCampaign[] = [];
  private offset: number = 0;
  private length: number|null = 4;
  private totaleItems: number = 0;
  private isOpend = false;
  get showMore() {
    if (this.totaleItems > this.defaultItems) {
      return true;
    } else {
      return false;
    }
  }
  @Emit()
  private setList(list: PostDataCampaign[]) {
    this.list = list;
  }
  @Emit()
  private async getMore() {
    // this.offset = this.firstItemsLength;
    if (this.length && this.length > 0) {
      this.length = null;
      await this.getEntries();
    }
    if (this.isOpend) {
      this.isOpend = false;
    } else {
      this.isOpend = true;
    }
    this.$nextTick(() => {
      if (!this.$refs.list) return
      const $list: any = $(this.$refs.list);
      if (this.isOpend) {
        $list.find('.item:hidden').stop().slideDown();
      } else {
        $list.find('.item:gt(' + (this.defaultItems - 1) + ')').stop().slideUp();
      }
    });
  }
  @Emit()
  private async getEntries() {
    let params:any = {
      offset: this.offset,
    }
    if (this.length) {
      params.length = this.length;
    }
    await fetchPostsCampaign(params)
    .then( (response) => {
      this.totaleItems = Number(response.hits);
      this.setList(response.datas);
    })
    .catch( (e) => {
      console.error(e);
    });
  }
}
